import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { createRoot } from 'react-dom/client';
import 'es6-promise/auto';

import { store } from './ducks';
import UserRoutes from './routes/routes';
//import '@ant-design/v5-patch-for-react-19';
// Bootstrap styles
//import 'bootstrap/dist/css/bootstrap.min.css';
require('bootstrap/dist/css/bootstrap.min.css');

// Load environment-specific styles
if (process.env.REACT_APP_STAGE === 'PROD') {
  require('./resources/CleanStyles/Vendors/vendors.cleanui.scss');
  require('./resources/AntStyles/AntDesign/antd.cleanui.scss');
  require('./resources/CleanStyles/Core/core.cleanui.scss');
} else {
  require('./resources/CleanStyles/Vendors/vendors.cleanui.scss');
  require('./resources/AntStyles/AntDesign/antd.cleanui.scss');
  require('./resources/CleanStyles/Core/devcore.cleanui.scss');
}

// Initialize React app
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <UserRoutes />
    </BrowserRouter>
  </Provider>
);
